import { CodeGenerationContextProvider } from '@common/git/CodeGeneration/context';
import { ProjectContextProvider } from '@common/git/Project/context';
import { UnloadHandler } from '@common/ide/UnloadHandler';
import { LogMessageProvider } from '@common/LogMessageContext';
import { Private_Routes } from '@common/url';
import { useDecodedParams } from '@common/utils/hooks/params';
import { BaseLSPClient } from '@LSP/base/BaseLSPClient';
import { BaseLSPProvider } from '@LSP/base/BaseLSPContext';
import { DiagnosticProvider } from '@LSP/DiagnosticProvider';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { useMemo, useEffect } from 'react';
import { Provider } from 'react-redux';

import { useLoggerState, LogProvider } from '../../generic-components/Logger/RuntimeLogger';
import { getLineageEditorWSEndPoint } from '../../utils/getServerUrl';
import { isWebsocketCompressionEnabled } from '../../utils/localstorage-keys';
import { Container } from './Container';
import { useLineageEditor } from './hook';

function LineagePageContent() {
  const lspClient = useMemo(
    () =>
      new BaseLSPClient(getLineageEditorWSEndPoint(), {
        compressionEnabled: isWebsocketCompressionEnabled
      }),
    []
  );
  const { projectId } = useDecodedParams<ExtractUrlPathVariables<typeof Private_Routes.Lineage_IDE.column.url>>();
  const { lineageStore } = useLineageEditor(lspClient, projectId);
  const loggerState = useLoggerState();
  useEffect(() => {
    return () => {
      lspClient.detach();
    };
  }, [lspClient]);

  return (
    <BaseLSPProvider client={lspClient}>
      <DiagnosticProvider>
        <ProjectContextProvider projectId={projectId}>
          <CodeGenerationContextProvider>
            <Provider store={lineageStore}>
              <UnloadHandler />
              <LogProvider value={loggerState}>
                <Container />
              </LogProvider>
            </Provider>
          </CodeGenerationContextProvider>
        </ProjectContextProvider>
      </DiagnosticProvider>
    </BaseLSPProvider>
  );
}

export default function LineagePage() {
  return (
    <LogMessageProvider>
      <LineagePageContent />
    </LogMessageProvider>
  );
}
